/**
 * hasher.service.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Injectable } from "@angular/core";
import { ConfigurationService } from "../configuration/configuration.service";

import "jssha";
/// <reference path="./jssha.d.ts"/>

/**
 * The {@link Hasher} is responsible for hashing strings, in particular the
 * sensitive parts of user {@link Credentials}.
 */
@Injectable()
export class Hasher {
  /**
   * The external library the {@link Hasher} class should hook into.
   */
  public library : jsSHAFactory;

  /**
   * The algorithm name to be provided to the hashing library.
   */
  private algorithm : HashType;

  /**
   * Create the {@link Hasher}.
   */
  constructor (protected config : ConfigurationService)
  {
    this.library = jsSHA;
    this.algorithm = this.config.protocol.hashAlgorithm;
  }

  /**
   * Write a UTF16 string into a string containing only UTF8 codepoints (UNUSED)
   */
  // tslint:disable-next-line:no-unused-variable
  private encode_utf8 (s : string) : string
  {
    return decodeURI(encodeURIComponent(s));
  }

  /**
   * Get the hash of a given plaintext as a hexadecimal string.
   */
  public hexOf (plaintext : string, inputType : InputType = "ARRAYBUFFER")
    : string
  {
    const hash : jsSHALibrary = new this.library(this.algorithm, inputType);
    const byteArray : Uint8Array = (new TextEncoder()).encode(plaintext);
    // USED TO BE: TextEncoder("utf-8")
    // NOTE: We're acting upon the typed array, not the buffer, like the API
    // requests. Acting upon the ArrayBuffer gives us a non-matching result.
    // TODO: Determine that this actually makes sense.
    hash.update(byteArray);

    return (hash.getHash("HEX") as string).toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/auth/hasher.service.ts